export default __webpack_public_path__ + "static/media/Shadow_pfp.2200197f.png";